import { Box } from '@utex/ui-kit';
import React, { ReactNode, ElementType, ButtonHTMLAttributes } from 'react';
import { Item, Icon, Wrapper } from './styles';

export type SizeType = 'M' | 'XS';
export type ViewType = 'normal' | 'hint' | 'negative';

interface NavItemProps {
  as?: ElementType;
  href?: string;
  target?: string;
  view?: ViewType;
  size?: SizeType;
  icon?: ReactNode;
  children?: ReactNode;
  isActive?: boolean;
  isExpand?: boolean;
  isOpen?: boolean;
  onClick?: (e: any) => void;
}

export const NavItem = React.forwardRef((props: NavItemProps, ref) => {
  const {
    as,
    target,
    href,
    view = 'normal',
    size = 'M',
    icon,
    isActive = false,
    isExpand,
    isOpen,
    onClick,
    children,
    ...other
  } = props;

  const defineType = (): ButtonHTMLAttributes<HTMLButtonElement>['type'] => {
    if ((!props.href && !props.as) || props.as === 'button') return 'button';
    return undefined;
  };

  return (
    <Item
      ref={ref as React.RefObject<HTMLAnchorElement>}
      as={as}
      target={target}
      href={href}
      type={defineType()}
      view={view}
      size={size}
      isActive={isActive}
      isExpand={isExpand}
      onClick={onClick}
      isOpen={isOpen}
      {...other}
    >
      <Wrapper>
        {icon && <Icon>{icon}</Icon>}
        <Box flexGrow={1} padding={size === 'M' ? [2, 0] : undefined}>
          {children}
        </Box>
      </Wrapper>
    </Item>
  );
});
